module.exports = __webpack_public_path__ + "img/04155259000243.6914a63d.png";